import get from "lodash.get";
import styled from "styled-components";
import DateImage from "../../../assets/images/date.png";

export const StyledInput = styled.input<any>`
  border-radius: 8px;
  border: 1px solid
    ${({ error, theme }) => (error ? theme.error.main : theme.form.light)};
  box-sizing: border-box;
  width: ${(props: any) => (props.type === "checkbox" ? "auto" : "100%")};
  color: ${({ theme }) => theme.secondary.dark} !important;
  padding: 10px 16px;
  padding-right: ${({ isHaveIcon }) => (isHaveIcon ? "40px" : "")};
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: -0.02em;
  outline: none;
  font-weight: 500;
  transition: 0.2s ease all;
  background-color: ${({ error, theme }) =>
    error ? theme.white.main : theme.form.light};
  &::-webkit-inner-spin-button,
  &::-webkit-calendar-picker-indicator {
    display: ${(props) =>
      props.type === "number" || props.type === "time" ? "none" : "block"};
    position: absolute;
    background-image: url(${DateImage});
    width: 17px;
    right: 5px;
    top: 50%;
    transform: translateY(-50%);
    height: 17px;
    background-repeat: no-repeat;
  }
  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus {
    -webkit-text-fill-color: ${({ theme }) => theme.secondary.dark} !important;
  }

  &:focus {
    box-shadow: none;
    border-color: ${({ error, theme }) =>
      error ? theme.error.main : theme.form.main};
    background-color: ${({ error, theme }) =>
      error ? theme.white.main : theme.form.main};
  }
  &::placeholder {
    color: #999;
    font-weight: 400;
    opacity: 0.9;
  }
`;

interface SType {
  text?: string;
  count?: string;
}

export const StyledInputContent = styled.div<SType>`
  position: relative;
  &:before {
    content: ${(props) => props.text};
    position: absolute !important;
    top: 50%;
    transform: translateY(-50%);
    right: 10px;
    font-size: 15px;
    color: ${({ theme }) => get(theme, "black.dark")};
  }
  &:after {
    content: ${(props) => props.count};
    position: absolute !important;
    bottom: -17.5px;
    right: 1px;
    font-size: 14px;
    color: ${({ theme }) => get(theme, "black.medium")};
  }
  display: flex;

  input[type="color"] {
    height: 40px;
  }
`;
export const StyledLabel = styled.label<any>`
  color: ${({ theme }) => theme.info.dark};
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 21px;
  letter-spacing: -0.02em;
  margin-bottom: 6px;
  display: flex;
  align-items: center;
  position: relative;
  gap: 15px;

  svg {
    cursor: pointer;
    path {
      transition: all 0.3s ease;
    }
    &:hover {
      path {
        fill: #019ef7;
      }
    }
  }

  .info_icon {
    width: 35px;
    background-color: inherit;
    display: flex;
    justify-content: center;
    align-items: center;
    svg {
      cursor: pointer;
      transform: scale(1.1);
      transition: all 0.3s ease;

      &:hover {
        path {
          transition: all 0.3s ease;
          fill: #019ef7;
        }
      }
    }
  }
`;
